// Static display vocabulary + tag helpers for transaction/freebet rows. Lives in
// core so the mappers can build render-ready view models with it (components then
// render only). Pure — no React, no store.

// players.bets rows arrive tagged with one of these top-level types.
export const TRANSACTION_TYPE = {
  BET: 'BET',
  PURCHASE: 'PURCHASE',
  REWARD: 'REWARD',
}

// transactionSubType enum -> human label
export const SUB_TYPE_LABEL = {
  MANUAL: 'Manual',
  AUTO: 'Auto',
  FREEBET: 'Freebet',
  BUY_BONUS: 'Buy Bonus',
  JACKPOT: 'Jackpot',
  TOURNAMENT: 'Tournament',
}

// transactionSourceType enum -> human label (freebet origin)
export const SOURCE_LABEL = {
  PURCHASED: 'Purchased',
  MISSION: 'Mission',
  TOURNAMENT: 'Tournament',
  JACKPOT: 'Jackpot',
  RAIN: 'Rain',
  CUSTOM: 'Custom',
}

// bet-transaction status enum -> human label
export const STATUS_LABEL = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CREDIT_RETRY: 'Credit Retry',
  REFUNDED: 'Refunded',
}

// freebet-grant status enum -> human label (ROOT vocabulary)
export const FREEBET_STATUS_LABEL = {
  ACTIVE: 'Active',
  FREEBET_INITIATED: 'In Play',
  CLAIMED: 'Claimed',
  EXPIRED: 'Expired',
  DROPPED: 'Dropped',
  INACTIVE: 'Inactive',
}

// Lookups fall back to the raw enum if the BE adds a new value, and to '—' when
// the value is missing/empty (never render blank).
export const subTypeLabel = (subType) => SUB_TYPE_LABEL[subType] ?? (subType || '—')
export const sourceLabel = (source) => SOURCE_LABEL[source] ?? (source || '—')
export const statusLabel = (status) => STATUS_LABEL[status] ?? (status || '—')
export const freebetStatusLabel = (status) => FREEBET_STATUS_LABEL[status] ?? (status || '—')

// A bet won when cashed out in profit.
export const isWin = (result) => result === 'WON' || result === 'CASHED_OUT'

// Freebet display tag: FB + id + a per-source letter (e.g. "FB101807C").
const FREEBET_SOURCE_LETTER = {
  PURCHASED: 'B',
  BONUSBUY: 'B',
  MISSION: 'M',
  TOURNAMENT: 'T',
  JACKPOT: 'J',
  RAIN: 'R',
  CUSTOM: 'C',
}
export const freebetTag = ({ id, source } = {}) => {
  if (!id) return 'FB'
  return `FB${id}${FREEBET_SOURCE_LETTER[source] ?? 'F'}`
}

// Middle-truncate a long id/tag for display, keeping the head + tail visible (so
// the FB prefix and the trailing type letter survive): "FBFB_9d8…f289R".
export const clipId = (value, head = 8, tail = 5) => {
  const s = String(value ?? '')
  return s.length <= head + tail + 1 ? s : `${s.slice(0, head)}…${s.slice(-tail)}`
}
